import { render, staticRenderFns } from "./boolean-radio-item.vue?vue&type=template&id=7889d5a8&"
import script from "./boolean-radio-item.vue?vue&type=script&lang=ts&"
export * from "./boolean-radio-item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7889d5a8')) {
      api.createRecord('7889d5a8', component.options)
    } else {
      api.reload('7889d5a8', component.options)
    }
    module.hot.accept("./boolean-radio-item.vue?vue&type=template&id=7889d5a8&", function () {
      api.rerender('7889d5a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/boolean-radio-item.vue"
export default component.exports